"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * Set an attendee name
 */
function setAttendeeName(attendeeId, name, presenterPhoto) {
  var role = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_ATTENDEE_NAME, {
    attendeeId: attendeeId,
    name: name,
    presenterPhoto: presenterPhoto,
    role: role
  });
}
var _default = exports["default"] = setAttendeeName;